import { APP_CACHE, NEW_PROPERTY_SYSTEM_SETTINGS } from "../app/config";
import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    SET_MESSAGE,
    PROFILE_FAILED,
    PROFILE_SUCCESS,
    //For reset password
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,
    // 2FA
    TWO_FACTOR_REQUIRED,
    TWO_FACTOR_VERIFY,
    TWO_FACTOR_SUCCESS,
    TWO_FACTOR_FAIL,
    TWO_FACTOR_RESEND,
} from "./types";
import { addToSession, getFromSession, getDataSources, clearAPIRegistryData, getSeriesById, addToLocalStorage, whichPricingModelSeasonData } from "../app/util";
import { API_REGISTRY } from "../app/config";
import { fetchDataSimple } from "../services/data.service";
import DataService from "../services/data.service";
import AuthService from "../services/auth.service";
import IndexedDBManager from "../indexed-db/indexed-db";



export const getUserProfile = (payload) => (dispatch) => {
    const { UserProfile, GetPropData, ReleaseNotes } = API_REGISTRY;
    return DataService.getData(payload).then(
        (data) => {
            let payLoadData = data.user_profile;
            payLoadData.justLoggedIn = true;
            //   debugger;
            //Do some task here just after response
            //Handle API response change for profile
            if (data && data.status === "success") {
                let system_settings = {};
                let defaultPropIndex = 0;
                let defaultProp = payLoadData.property_details.filter((prop, i) => {
                    if (prop.default === 'Y') {
                        defaultPropIndex = i;
                        return prop.default === 'Y';
                    }
                });

                if (defaultProp && defaultProp.length && defaultProp[0].system_settings) {
                    system_settings = defaultProp[0].system_settings;
                    if (system_settings && !system_settings[0].inventory_settings) {
                        console.error("CRITICAL: System settings -> Inventory settings not available");
                        payLoadData.property_details[defaultPropIndex].system_settings[0] = { ...NEW_PROPERTY_SYSTEM_SETTINGS, ...system_settings[0] };
                    }
                }
                //
                const { user_profile } = data;
                const { default_property_id, default_view } = user_profile;
                APP_CACHE.user_view = default_view;
                const requestUri = GetPropData.uri.replace('{pid}', default_property_id);
                fetchDataSimple({ api: requestUri, request: { method: 'GET' } })
                    .then((rs) => {
                        let cache_data = { data: rs, loaded: true, loading: false, reqParams: { api: requestUri, request: { method: 'GET' } } };
                        DataService.updateDataCache("GetPropData", cache_data);
                        payLoadData.property_details[defaultPropIndex].product_variant = rs.pv;
                        payLoadData.current_property_date = rs.current_date;
                        payLoadData.current_property_time_zone = rs.timezone;
                        if (rs.pv && rs.pv.default_tile) {
                            APP_CACHE.active_tile = rs.pv.default_tile;
                            APP_CACHE.active_tiles = [rs.pv.default_tile];
                        } else {
                            APP_CACHE.active_tile = 'otb';
                            APP_CACHE.active_tiles = ['otb'];
                        }

                        /** LRV-1046 send api to get new release data */
                        fetchDataSimple({ api: ReleaseNotes.uri, request: { method: 'GET' } })
                            .then((tourListData) => {
                                if (tourListData && tourListData.status === "success" && Object.keys(tourListData.data).length) {
                                    localStorage.setItem('tourListApiData', JSON.stringify(tourListData.data));
                                    localStorage.setItem('tours_not_show_again', user_profile.tours_not_show_again);
                                } else {
                                    localStorage.setItem('tourListApiData', false);
                                }
                            })
                        /** End LRV-1046 */
                        payLoadData.property_details.forEach(prop => {
                            if (prop.id === default_property_id) {
                                let pricingModelNo = whichPricingModelSeasonData(prop.system_settings[0].pricing_settings.room_dow_plans, prop.permissions.pricing_model);
                                if (pricingModelNo !== prop.permissions.pricing_model) {
                                    prop.system_settings[0].pricing_settings.room_dow_plans = [];
                                }
                            }
                        })
                        dispatch({ type: PROFILE_SUCCESS, payload: payLoadData });
                        return Promise.resolve(data);
                    }, (error) => {
                        console.error(error);
                    });
            }
            if (data && data.status !== "success") {
                dispatch({ type: PROFILE_FAILED, payload: data });
                return Promise.reject(data);
            }
        }
    )
};

export const login = (payload) => (dispatch) => {
    return AuthService.login(payload).then(
        (data) => {
            if (data.status === "success" && data.temp_token) {
                dispatch({
                    type: TWO_FACTOR_REQUIRED,
                    payload: {
                        tempToken: data.temp_token,
                        delivery: data.delivery,
                        maskedDestination: data.masked_dest,
                        expiresIn: data.expires_in,
                    },
                });
                return Promise.resolve({ twoFactorRequired: true });
            }

            if (data.status === "success") {
                const tokenValue = data?.auth_tokens?.session?.key || data.token_string || data.token;
                addToSession("token", tokenValue);

                // lrv-1095
                // addToLocalStorage("isLoginEnabled", true);
                addToLocalStorage("token", tokenValue);

                dispatch({
                    type: LOGIN_SUCCESS,
                    payload: { user: { ...data, token_string: tokenValue } },
                });

                APP_CACHE.active_tiles = [];
                APP_CACHE.active_tile = '';
                APP_CACHE.yearDataStaus = {}; // added for flash report
                //Cleaning indexed db for API response cache
                const idbManager = new IndexedDBManager();
                idbManager.openDB()
                    .then(() => {
                        idbManager.cleanIdbStore();
                    })
                    .then(() => {
                        idbManager.closeDB();
                    });

                return Promise.resolve(data);
            } else {

                dispatch({
                    type: LOGIN_FAIL,
                });
                dispatch({
                    type: SET_MESSAGE,
                    payload: data.message,
                });
                return Promise.reject(data.message);
            }
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            dispatch({
                type: LOGIN_FAIL,
            });
            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });
            return Promise.reject();
        }
    );
};


export const getReleaseNotes = (payload) => (dispatch) => {
    return AuthService.getReleaseNotes(payload).then(
        (data) => {
            debugger;
            if (data.status === "success") {
                const tokenValue = data?.auth_tokens?.session?.key || data.token_string || data.token;
                addToSession("token", tokenValue);
                dispatch({
                    type: LOGIN_SUCCESS,
                    payload: { user: { ...data, token_string: tokenValue } },
                });

                APP_CACHE.active_tiles = [];
                APP_CACHE.active_tile = '';
                APP_CACHE.yearDataStaus = {}; // added for flash report
                //Cleaning indexed db for API response cache
                const idbManager = new IndexedDBManager();
                idbManager.openDB()
                    .then(() => {
                        idbManager.cleanIdbStore();
                    })
                    .then(() => {
                        idbManager.closeDB();
                    });

                return Promise.resolve(data);
            } else {

                dispatch({
                    type: LOGIN_FAIL,
                });
                dispatch({
                    type: SET_MESSAGE,
                    payload: data.message,
                });
                return Promise.reject(data.message);
            }
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            dispatch({
                type: LOGIN_FAIL,
            });
            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });
            return Promise.reject();
        }
    );
};


export const logout = () => (dispatch) => {
    let token = getFromSession('token');
    dispatch({
        type: LOGOUT,
    });
    const idbManager = new IndexedDBManager();
    idbManager.openDB()
        .then(() => {
            idbManager.cleanIdbStore();
        })
        .then(() => {
            idbManager.closeDB();
        });

    AuthService.logout({ token: token })
        .then((rs) => {
            clearAPIRegistryData();
            dispatch({ type: 'USER_LOGOUT' });

            setTimeout(() => {
                // debugger;
                // window.location.reload();
            }, 50)
            //window.location.reload();
        });


    const openTabs = JSON.parse(localStorage.getItem('openTabs') || '[]');
    const currentTabId = sessionStorage.getItem('currentTabId');
    // if (openTabs.length > 0 && openTabs[0] === currentTabId) {
    if (openTabs.length > 0 && openTabs[0] === currentTabId && openTabs.includes(currentTabId)) {
        let zendeskLogout = 'https://lodgiqhelp.zendesk.com/access/logout?return_to=https://lodgiqhelp.zendesk.com/hc/en-us';
        let width = 1;  // Set the width of the mini window
        let height = 1; // Set the height of the mini window
        let left = window.screen.width - width; // Position the window at the right edge of the screen
        let top = window.screen.height - height; // Position the window at the bottom of the screen
        let newTab = window.open(
            zendeskLogout, '_blank',
            `width=${width},height=${height},left=${left},top=${top},scrollbars=no,resizable=no`
        );
        setTimeout(function () {
            newTab.close();
        }, 500);
    }
};

export const verifyOTP = ({ otp, tempToken, trustDevice, deviceId }) => (dispatch) => {
    dispatch({ type: TWO_FACTOR_VERIFY });
    return AuthService.verifyOTP({ otp, tempToken, trustDevice, deviceId }).then(
        (data) => {
            if (data.status === "success") {
                const tokenValue = data?.auth_tokens?.session?.key || data.token_string || data.token;
                addToSession("token", tokenValue);
                addToLocalStorage("token", tokenValue);
                dispatch({ type: TWO_FACTOR_SUCCESS });
                dispatch({ type: LOGIN_SUCCESS, payload: { user: { ...data, token_string: tokenValue } } });
                APP_CACHE.active_tiles = [];
                APP_CACHE.active_tile = '';
                APP_CACHE.yearDataStaus = {};
                const idbManager = new IndexedDBManager();
                idbManager.openDB().then(() => idbManager.cleanIdbStore()).then(() => idbManager.closeDB());
                return Promise.resolve(data);
            } else {
                dispatch({ type: TWO_FACTOR_FAIL, payload: data.message });
                return Promise.reject(data.message || 'Invalid OTP');
            }
        },
        (error) => {
            const message = (error.response?.data?.message) || error.message || error.toString();
            dispatch({ type: TWO_FACTOR_FAIL, payload: message });
            return Promise.reject(message);
        }
    );
};

export const resendOTP = ({ tempToken }) => (dispatch) => {
    return AuthService.resendOTP({ tempToken }).then(
        (data) => {
            if (data.temp_token) {
                dispatch({ type: TWO_FACTOR_RESEND, payload: { tempToken: data.temp_token } });
            }
            return Promise.resolve(data);
        },
        () => Promise.reject('Failed to resend OTP')
    );
};

export const resetPassword = (payload) => (dispatch) => {
    return AuthService.resetPassword(payload).then(
        (data) => {
            if (data.status === "success") {
                dispatch({
                    type: RESET_PASSWORD_SUCCESS,
                    payload: { user: data },
                });
                return Promise.resolve();
            } else {
                dispatch({
                    type: RESET_PASSWORD_FAIL,
                });
                dispatch({
                    type: SET_MESSAGE,
                    payload: data.error_message,
                });
                return Promise.reject(data.error_message);
            }
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            dispatch({
                type: LOGIN_FAIL,
            });
            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });
            return Promise.reject();
        }
    );
};